import React from "react";

// Soft range for slider; hard range for numeric field
const SOFT_MIN = 10;
const SOFT_MAX = 800;
const HARD_MIN = 10;
const HARD_MAX = 2000;

const clamp = (v: number, min: number, max: number) => Math.min(max, Math.max(min, v));

const CaseSizeCalculator = ({
  setCaseSizePx,
  caseSizePx,
}: {
  setCaseSizePx: (size: number) => void;
  caseSizePx: number;
}) => {
  const handleSliderChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newCaseSizePx = clamp(Number(event.target.value), SOFT_MIN, SOFT_MAX);
    setCaseSizePx(newCaseSizePx);
  };

  const handleNumberChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const raw = event.target.value;
    if (raw === "") return; // ignore empty string
    const n = Number(raw);
    if (Number.isNaN(n)) return;
    setCaseSizePx(clamp(Math.round(n), HARD_MIN, HARD_MAX));
  };

  const nudge = (delta: number) => () => {
    const next = clamp(Math.round(caseSizePx + delta), HARD_MIN, HARD_MAX);
    setCaseSizePx(next);
  };

  const outOfSliderRange = caseSizePx > SOFT_MAX || caseSizePx < SOFT_MIN;

  return (
    <div>
      <p>Taille de la case en pixels: {caseSizePx}px</p>
      <input
        type="range"
        min={SOFT_MIN}
        max={SOFT_MAX}
        step={1}
        value={clamp(caseSizePx, SOFT_MIN, SOFT_MAX)}
        onChange={handleSliderChange}
        style={{ width: "100%" }}
      />
      {outOfSliderRange && (
        <p style={{ fontSize: "0.9rem", color: "#6b7280", marginTop: 6 }}>
          La valeur dépasse la plage du curseur&nbsp;: utilisez le champ numérique pour ajuster.
        </p>
      )}

      <div style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 12 }}>
        <button type="button" onClick={nudge(-10)} className="px-2 py-1 border rounded">-10</button>
        <button type="button" onClick={nudge(-1)} className="px-2 py-1 border rounded">-1</button>
        <input
          type="number"
          min={HARD_MIN}
          max={HARD_MAX}
          step={1}
          value={caseSizePx}
          onChange={handleNumberChange}
          className="border p-2 w-28 text-center"
        />
        <button type="button" onClick={nudge(1)} className="px-2 py-1 border rounded">+1</button>
        <button type="button" onClick={nudge(10)} className="px-2 py-1 border rounded">+10</button>
      </div>

      <p style={{ marginTop: 12 }}>
        Validez la taille une fois que la case fait 4&nbsp;cm de côté.
      </p>
      <div
        style={{
          width: `${caseSizePx}px`,
          height: `${caseSizePx}px`,
          border: "1px solid black",
          backgroundColor: "lightgray",
          display: "inline-block",
          marginTop: "10px",
        }}
      >
        Case
      </div>
    </div>
  );
};

export default CaseSizeCalculator;
